import React from 'react';

export default function MarketSpread() {
  return (
    <section className="pt-28 pb-32 px-4 bg-[#060b29] text-white min-h-screen">
      <div className="max-w-4xl mx-auto text-center">
        <h1 style={{ marginBottom: '50px' }} className="text-4xl md:text-5xl font-bold text-white">
          Market Spread & Swaps
        </h1>

        {/* Spread Section */}
        <div>
          <h2 className="text-purple-300 mb-2" style={{ fontSize: '32px' }}>
            What is Market Spread?
          </h2>
          <p className="text-gray-300 leading-relaxed" style={{ fontSize: '20px', marginBottom: '40px' }}>
            The <strong>spread</strong> is the difference between the bid (buy) and ask (sell) price of a trading pair.
            It represents the cost of entering a trade and varies based on liquidity, volatility, and asset type.<br /><br />
            🔹 <strong>Forex Spreads</strong>: Major pairs like EUR/USD often have tighter spreads.<br />
            🔹 <strong>Commodities</strong>: Gold and silver may show wider spreads during volatile sessions.<br />
            🔹 <strong>Crypto</strong>: Due to decentralized nature, spreads can be higher during low-volume hours.
          </p>
        </div>

        {/* Swap Section */}
        <div>
          <h2 className="text-purple-300 mb-2" style={{ fontSize: '32px' }}>
            What are Swaps?
          </h2>
          <p className="text-gray-300 leading-relaxed" style={{ fontSize: '20px', marginBottom: '40px' }}>
            A <strong>swap</strong> (or rollover fee) is the interest charged or earned for holding a position overnight.
            It depends on the interest rate differential between the two currencies in a forex pair,
            or cost of carry in commodities/crypto.<br /><br />
            🔄 <strong>Positive Swap</strong>: You earn interest if the currency you buy has a higher rate.<br />
            🔻 <strong>Negative Swap</strong>: You pay interest if the currency you sell has a higher rate.<br />
            📆 <strong>Triple Swap on Wednesdays</strong>: For forex, 3-day swaps apply mid-week to cover the weekend.
          </p>
        </div>

        {/* Pipplus Benefits */}
        <div>
          <h2 className="text-purple-300 mb-2" style={{ fontSize: '32px' }}>
            How Pipplus Helps You
          </h2>
          <p className="text-gray-300 leading-relaxed" style={{ fontSize: '20px', marginBottom: '40px' }}>
            Our algo engine is optimized to:<br /><br />
            ✅ Avoid high-spread conditions with dynamic entry filtering<br />
            ✅ Factor swap rates into overnight trade planning<br />
            ✅ Maximize profit potential by leveraging low-spread execution windows
          </p>
        </div>
      </div>
    </section>
  );
}
